import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CompanyPartnerDto } from 'src/app/domain/models/dto/company-partner.dto';
import { PersonalCheckDto } from 'src/app/domain/models/dto/personal-check.dto';
import { ResponseObjectModel } from 'src/app/domain/models/response-object.model';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '.';

@Injectable({
  providedIn: 'root'
})
export class CompanyPartnerService {

  getByCompany() {
    return this.http.get<ResponseObjectModel<CompanyPartnerDto[]>>(`${environment.API_BASE_URL}/v1/company-partners/corporate-accounts/${this.authService.getCompanyId()}`);
  }

  validateSituation(companyPartnerId: number) {
    return this.http.get<ResponseObjectModel<PersonalCheckDto[]>>(`${environment.API_BASE_URL}/v1/company-partners/${companyPartnerId}/personal-checks/validate`);
  }

  constructor(private readonly http: HttpClient, private authService: AuthenticationService) { }

  registerMany(companyPartners: CompanyPartnerDto[]) {
    return this.http.post<ResponseObjectModel<CompanyPartnerDto>>(`${environment.API_BASE_URL}/v1/company-partners`, companyPartners);
  }

  register(companyPartner: CompanyPartnerDto) {
    return this.http.post<ResponseObjectModel<CompanyPartnerDto>>(`${environment.API_BASE_URL}/v1/company-partners`, companyPartner);
  }

  public uploadDocumentFile(id: number, file: any) {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.put<ResponseObjectModel<CompanyPartnerDto>>(`${environment.API_BASE_URL}/v1/company-partners/${id}/document-file`, formData);
  }

  update(id: number, companyPartner: CompanyPartnerDto) {
    return this.http.put<ResponseObjectModel<CompanyPartnerDto>>(`${environment.API_BASE_URL}/v1/company-partners/${id}`, companyPartner);
  }

  delete(id: number) {
    return this.http.delete<ResponseObjectModel<any>>(`${environment.API_BASE_URL}/v1/company-partners/${id}`);
  }

  deleteFatca(id: number) {
    return this.http.delete<ResponseObjectModel<any>>(`${environment.API_BASE_URL}/v1/company-partners/${id}/fatca`);

  }
}
